import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faChevronLeft,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./Pagination.module.css";

const Pagination = ({
	currentPage,
	totalPages,
	indexOfFirstLog,
	indexOfLastLog,
	totalLectures,
	handlePageChange,
}) => {
	return (
		<div className={styles.paginationContainer}>
			<div className={styles.paginationInfo}>
				Showing {indexOfFirstLog + 1} to{" "}
				{Math.min(indexOfLastLog, totalLectures)} of {totalLectures} entries
			</div>
			<div className={styles.paginationControls}>
				<button
					className={styles.pageButton}
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage === 1}
				>
					<FontAwesomeIcon icon={faChevronLeft} />
				</button>

				{Array.from({ length: totalPages }, (_, i) => i + 1)
					.filter(
						(page) =>
							page === 1 ||
							page === totalPages ||
							(page >= currentPage - 1 && page <= currentPage + 1)
					)
					.map((page, index, array) => (
						<React.Fragment key={page}>
							{index > 0 && array[index - 1] !== page - 1 && (
								<span className={styles.pageEllipsis}>...</span>
							)}
							<button
								className={`${styles.pageButton} ${styles.numberButton} ${
									page === currentPage ? styles.active : ""
								}`}
								onClick={() => handlePageChange(page)}
							>
								{page}
							</button>
						</React.Fragment>
					))}

				<button
					className={styles.pageButton}
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage === totalPages}
				>
					<FontAwesomeIcon icon={faChevronRight} />
				</button>
			</div>
		</div>
	);
};

export default Pagination;
